<section class="flex align-center justify-center">
    <img *ngIf="!isTransparent" src="https://images.poshvine.com/icon/cir-load-big.gif">
    <img *ngIf="isTransparent" src="../../../assets/images/loader-transparent.gif">
</section>
